var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_3331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 6.00016L1.33325 8.00016M1.33325 8.00016L3.33325 10.0002M1.33325 8.00016H14.6666M5.99992 3.3335L7.99992 1.3335M7.99992 1.3335L9.99992 3.3335M7.99992 1.3335V14.6668M9.99992 12.6668L7.99992 14.6668M7.99992 14.6668L5.99992 12.6668M12.6666 6.00016L14.6666 8.00016M14.6666 8.00016L12.6666 10.0002",
    stroke: "#4D4D4D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_3331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayMoveIcon);
export default __webpack_public_path__ + "static/media/gray-move-icon.5c6d92da919279ba77204aeae759b04e.svg";
export { ForwardRef as ReactComponent };